<template>
  <div id="app">
    <template v-if="$route.name !== 'NotFound'">
      <Header />
    </template>
    <div class="view">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

import AOS from 'aos';

export default {
  components: { Header },
  data() {
    return {
      scrollTop: 0,
    };
  },
  created() {
    AOS.init({
      duration: 1000,
    });
  },
};

</script>

<style lang="scss">
#app {
  font-family: Pretendard, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1024px;
}
#app .view {
  position: fixed;
  width: 100%;
  height: 100vh;
  &> div {
    background: url('https://static.gabia.com/fonts/project/image/noise_bg.png') repeat center center;
  }
}
.font-project {
  video {
    pointer-events: none;
    transition: transform 1000ms ease;
    transform: scale(1);
  }
  &.ready {
    video {
      transform: scale(1.4);
    }
  }
}

section {
  position: relative;
  //height: 100vh;
  height: 1080px;
  padding: 100px 40px;
  .section-contents {
    width: 850px;
    min-width: 850px;
    margin: 0 auto;
    &> div {
      margin-bottom: 40px;
    }
  }
  .scroll-mark {
    position: absolute;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 1px;
    height: 70px;
    z-index: 9999;
    background-color: #0A0A0A;
    margin-bottom: 20px;
    &:after {
      content: '';
      position: absolute;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      left: 50%;
      transform: translateX(-50%);
      bottom: -20px;
      background-color: #0A0A0A;
    }
  }
}
.section-1 {
  position: relative;
  //height: 100vh;
  height: 1080px;
  padding: 0;
  text-align: center;
  z-index: 100;
  .contents-wrapper {
    position: absolute;
    width: 100%;
    min-width: 1024px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    text-align: center;
  }
}
header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
}
footer {
  //position: absolute;
  //bottom: 0;
  //left: 0;
  //width: 100%;
}
.move-top {
  position: fixed;
}
.cheongyeon {
  font-family: 'Cheongyeon';
  font-weight: 100;
}
.maeumgyeol {
  font-family: 'Maeumgyeol';
  font-weight: 100;
}
.heuldot {
  font-family: 'Heuldot';
  font-weight: 100;
}
.ondam {
  font-family: 'Ondam';
  font-weight: 100;
}
.gosran {
  font-family: 'Gosran';
  font-weight: 100;
}
.null {
  font-family: 'Null';
  font-weight: 100;
}
section.section-1 {
  .contents-wrapper {
    .type-main-title {
      min-height: 200px;
      margin-bottom: 50px;
    }
    .type-main-description {
      text-align: center;
      font-size: 30px;
      align-items: center;
      &> span {
        display: inline;
        padding-bottom: 10px;
        border-bottom: 1px solid #0A0A0A;
        margin-bottom: 20px;
      }
    }
  }

}
</style>
